import { render, staticRenderFns } from "./CustomerOnetimeExport.vue?vue&type=template&id=71240730&scoped=true"
import script from "./CustomerOnetimeExport.vue?vue&type=script&lang=js"
export * from "./CustomerOnetimeExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71240730",
  null
  
)

export default component.exports